import { render, staticRenderFns } from "./DropdownHead.vue?vue&type=template&id=534dd255&scoped=true"
import script from "./DropdownHead.vue?vue&type=script&lang=js"
export * from "./DropdownHead.vue?vue&type=script&lang=js"
import style0 from "./DropdownHead.vue?vue&type=style&index=0&id=534dd255&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534dd255",
  null
  
)

export default component.exports